"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Actions_1 = require("../Actions");
var Client_1 = require("./Client");
var CampusClient = /** @class */ (function (_super) {
    __extends(CampusClient, _super);
    function CampusClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClientIsReady = function (data) {
            _this.postMessage(Actions_1.default.CLIENT_READY, data);
        };
        _this.onExerciseIsReady = function (data) {
            _this.postMessage(Actions_1.default.EXERCISE_READY, data);
        };
        _this.onExerciseStatusUpdate = function (data) {
            _this.postMessage(Actions_1.default.SET_EXERCISE_STATUS, data);
        };
        _this.onExerciseFinished = function (data) {
            _this.postMessage(Actions_1.default.EXERCISE_FINISHED, data);
        };
        _this.onExerciseSubmitted = function (data) {
            _this.postMessage(Actions_1.default.EXERCISE_SUBMITTED, data);
        };
        return _this;
    }
    CampusClient.prototype.onXpUpdated = function (data) {
        this.postMessage(Actions_1.default.SET_EXERCISE_XP, data);
    };
    return CampusClient;
}(Client_1.default));
exports.default = CampusClient;
//# sourceMappingURL=CampusClient.js.map